// Arabic translations for OC MENA Festival headings and common terms
// Using Aldhabi font for Arabic text

export const ARABIC_TRANSLATIONS = {
  // Main headings
  'OC MENA Festival': 'مهرجان أو سي مينا',
  'Music & Entertainment': 'الموسيقى والترفيه',
  'About': 'عن',
  'Vendors': 'البائعين',
  'Tickets': 'تذاكر',
  'Home': 'الرئيسية',
  'Sponsors': 'الرعاة',
  'Contact': 'اتصل بنا',
  'FAQ': 'الأسئلة الشائعة',
  
  // Days
  'FRIDAY': 'الجمعة',
  'SATURDAY': 'السبت', 
  'SUNDAY': 'الأحد',
  'THREE DAYS': 'ثلاثة أيام',
  
  // Stage names
  'Festival Stage': 'مسرح المهرجان',
  'Indoor Stage': 'المسرح الداخلي',
  'Pacific Amphitheatre': 'المسرح الرئيسي لحفلة الغناء',
  'Pacific Amphitheatre Tickets': 'تذاكر المسرح الرئيسي',
  'Festival Tickets': 'تذاكر المهرجان',
  '1-Day Pass': 'تذكرة ليوم واحد',
  '2-Day Pass': 'تذكرة ليومين',
  '3-Day Pass': 'تذكرة لثلاثة أيام',
  
  // Vendor types
  'Bazaar Vendors': 'بائعين البازارات',
  'Food/Beverage Vendors': 'بائعين الطعام والمشروبات',
  'Food Vendors': 'بائعين الطعام',
  'Bazaar': 'سوق',
  'Vendors that are coming to the Festival': 'البائعين القادمون إلى المهرجان',
  
  // Common terms
  'Rides': 'ألعاب',
  'Food': 'طعام',
  'Prayer Room': 'مصلى',
  'Hookah': 'شيشة',
  'Comedy Show': 'عرض كوميدي',
  'Entrance': 'الدخول',
  'Entrance Gate': 'بوابة الدخول',
  'Parking': 'موقف السيارات',
  '5 PM': '٥ مساءً',
  
  // Time units
  'days': 'أيام',
  'hrs': 'ساعات',
  'mins': 'دقائق',
  'secs': 'ثواني',
  
  // Action buttons
  'Get Tickets': 'احصل على التذاكر',
  'Buy Tickets': 'اشترِ التذاكر',
  'Become a Vendor': 'كن بائعاً',
  
  // Section headings
  'Order Summary': 'ملخص الطلب',
  'Billing Address': 'عنوان الدفع',
  'Quick Actions': 'إجراءات سريعة',
  'Vendor Dashboard': 'لوحة تحكم البائع',
  'Registration Received': 'تم استلام التسجيل',
  'Premier Sponsorships': 'الرعاة الرئيسية ',
  'Micro Sponsorships': 'مايكرو رعاة',
  'Get in touch': 'تواصل معنا',
  
  // Status labels
  'Status': 'الحالة',
  'Orders': 'الطلبات',
  'Active': 'نشط',
  
  // Contact/Info
  'From': 'من',
  'Bill To': 'فاتورة إلى',
  'INVOICE': 'فاتورة',
  
  // General
  'Welcome': 'مرحباً',
  'Thank you': 'شكراً لك',
  'Something went wrong': 'حدث خطأ ما',
  
  // Festival specific
  'MENA Festival': 'مهرجان مينا',
  'Festival': 'مهرجان',
  
  // Additional pages
  'Event Schedule': 'جدول الفعاليات',
  'Event Map': 'خريطة الفعاليات',
  'Map & Directions': 'الخريطة والتوجيهات',
  'Maps & Directions': 'الخريطة والتوجيهات',
  'Account': 'حسابي',
  'My Account': 'حسابي',
  'Dashboard': 'لوحة التحكم',
  'Cart': 'سلة المشتريات',
  'Partners': 'الشركاء',
  'Media Relations': 'العلاقات الإعلامية',
  'VIP Relations': 'العلاقات لكبار الشخصيات',
  'Hiring Opportunities': 'فرص التوظيف',
  'Login': 'تسجيل الدخول',
  'Register': 'التسجيل',
  'Sign Up': 'إنشاء حساب',
  'Log In': 'تسجيل الدخول',
  'Lost your password?': 'نسيت كلمة المرور؟',
  'Full Name': 'الاسم الكامل',
  'Phone Number': 'رقم الهاتف',
  'Optional': '(اختياري)',
  'OC MENA Festival Vendor Booths': 'اكشاك البائعين في المهرجان',
  'What is MENA': 'ما هو مينا',
  'What is MENA?': 'ما هو مينا؟',
  'Festival Info': 'معلومات عن المهرجان',
  'Ticket Terms': 'شروط التذاكر',
  'Terms of Use': 'شروط الاستخدام',
  'Privacy Policy': 'سياسة الخصوصية',
  'Choose Your Pacific Amphitheatre Night': 'احجز تذكرتك للحفلة الغنائية',
  'Saturday': 'السبت',
  'Sunday': 'الأحد',
  'Sponsors Info': 'معلومات الرعاة',
  'About Vendors': 'حول البائعين',
};

// Helper function to get Arabic translation
export const getArabicTranslation = (text) => {
  return ARABIC_TRANSLATIONS[text] || text;
};

// Component to render bilingual heading
export const BilingualHeading = ({ 
  englishText, 
  className = '', 
  tag: Tag = 'h1',
  showArabic = true,
  arabicClassName = 'arabic-text'
}) => {
  const arabicText = getArabicTranslation(englishText);
  
  return (
    <Tag className={className}>
      {englishText}
      {showArabic && arabicText !== englishText && (
        <>
          <span className="arabic-separator"> • </span>
          <span className={arabicClassName}>{arabicText}</span>
        </>
      )}
    </Tag>
  );
};
